export default __webpack_public_path__ + "images/10a48f29c6f8d337655761257fbad334-walking.jpg";